import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class Hospital extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	@observable hospitals = [
		"Fiona Stanley Hospital",
		"Sir Charles Gairdner Hospital",
		"Royal Perth Hospital",
		"Fremantle Hospital",
		"Princess Margaret Hospital",
		"King Edward Memorial Hospital",
		"Joondalup Health Campus",
		"St John of God Midland",
		"St John of God Subiaco",
		"St John of God Murdoch",
		"Hollywood Private Hospital",
		"Mount Hospital",
		"Glengarry Hospital",
		"Bethesda Hospital",

	]

	componentDidMount() {
		this.props.store.step = 7
	}

	@computed get completed() {
		// const { doctor } = this.props.store
		// if (!( doctor.clinic.address)) { return false  }
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	handleHospital = (e) => {
		const { doctor } = this.props.store
		const indexOfHospital = doctor.hospitals.indexOf(e.target.name)
		if (indexOfHospital >= 0) {
			doctor.hospitals.splice(indexOfHospital,1)
		} else {
			doctor.hospitals.push(e.target.name)
		}
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2>7. Hospitals</h2>

				<h4>Please add any public or private hospitals you attend.</h4>
				
				{this.hospitals.map((hospital, index) =>
					<AHospital
						key={index}
						hospital={hospital}
						doctor={doctor}
						handleHospital={this.handleHospital} />
				)}
				
				<hr />

				<h4>Other(s) not listed</h4>
				
				{doctor.hospitalsMore && doctor.hospitalsMore.map((theHospital, index) =>
					<div key={index} className="m-b-1">
						<input
							className={`input medium m-r-1`}
							type="email"
							placeholder="Hospital..."
							value={theHospital.title} 
							onChange={e => { theHospital.title = e.target.value; }}
						/>
						<div className="btn base sm" onClick={()=>doctor.hospitalsMore.splice(index,1)}><i className="fa fa-fw fa-times"></i> Remove</div>
					</div>)}
				
				<div>
					<div
						onClick={()=>doctor.hospitalsMore.push({ title: ""})}
						className={`btn sm m-b-1`}><i className="fa fa-fw fa-plus"></i> Add Hospital</div>	
				</div>

				<hr/>

				<div className="m-t-1">
					<div
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>
				
			</div>
		);
	}
}

const AHospital = observer(({ hospital, doctor, handleHospital}) =>
	<div >				
		<label>
				<input type="checkbox" name={hospital} checked={doctor.hospitals.indexOf(hospital) >= 0} onChange={handleHospital}  />
			{hospital}
		</label>
</div>	)

export default Hospital;


// WEBPACK FOOTER //
// ./src/Containers/Listing/8.Hospital.js